import React from "react";
import { Container, Row, Col } from "shards-react";

const FullPageWidth = ({ children }) => (
    <Container fluidclassName="page-wrapper">
        <Row>
            <Col
                className="p-0"
                sm='12'
                md='12'
                lg='12'
                tag="main"
            >
                <div >
                    <hr />
                    {children}
                </div>
            </Col>
        </Row>
    </Container>
);

export default FullPageWidth;
